import { DiscoverContainer } from 'modules/Discover'
import React from 'react'

type Props = {}

const Discover = (props: Props) => {
  return (
    <DiscoverContainer />
  )
}

export default Discover